import React, { useEffect, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/store';
import {
  fetchStaticContent,
  isAppReadyWithStaticContent,
} from '../../store/contentSlice';
import { fetchFeatures } from '../../store/featureSlice';
import { fetchClientTermsAndConditions } from '../../store/termsAndConditionsSlice';

const StaticContentLoader = (): ReactElement => {
  const dispatch = useAppDispatch();
  const isContentNotRequested = useSelector(isAppReadyWithStaticContent);
  useEffect(() => {
    if (!isContentNotRequested) {
      dispatch(fetchStaticContent());
      dispatch(fetchFeatures());
      dispatch(fetchClientTermsAndConditions());
    }
  }, []);
  return <></>;
};

export default StaticContentLoader;
